import { useState, useEffect } from "react";

function Disability() {
  const [hasDisability, setHasDisability] = useState(false);
  const [disability, setDisability] = useState("");

  const handleRadioChange = (e) => {
    setHasDisability(e.target.value === "yes");
  };

  const handleDisabilityChange = (e) => {
    setDisability(e.target.value);
  };

  useEffect(() => {
    localStorage.setItem("hasDisability", hasDisability);
    if (hasDisability && disability) {
      localStorage.setItem("disability", disability);
    } else {
      localStorage.setItem("disability", "");
    }
  }, [hasDisability, disability]);

  useEffect(() => {
    const storedHasDisability = localStorage.getItem("hasDisability");
    if (storedHasDisability) {
      setHasDisability(storedHasDisability === "true");
    }
    const storedDisability = localStorage.getItem("disability");
    if (storedDisability) {
      setDisability(storedDisability);
    }
  }, []);

  return (
    <div className="p-6">
      <div className="flex items-center">
        <div className="mr-6">
          <input
            type="radio"
            id="disability-yes"
            name="disability"
            value="yes"
            checked={hasDisability}
            onChange={handleRadioChange}
            className="form-radio h-5 w-5 text-blue-600"
          />
          <label htmlFor="disability-yes" className="ml-2 block text-gray-700">
            Yes
          </label>
        </div>

        <div className="mr-6">
          <input
            type="radio"
            id="disability-no"
            name="disability"
            value="no"
            checked={!hasDisability}
            onChange={handleRadioChange}
            className="form-radio h-5 w-5 text-blue-600"
          />
          <label htmlFor="disability-no" className="ml-2 block text-gray-700">
            No
          </label>
        </div>
      </div>

      {hasDisability && (
        <div className="mt-4">
          <label className="block text-gray-700">
            Please specify:<span className="text-red-500 italic">*</span>
          </label>
          <input
            type="text"
            value={disability}
            placeholder="Please specify"
            onChange={handleDisabilityChange}
            className="mt-1 block w-full border-2 border-gray-400 rounded-[8px] h-20 px-4 py-2 focus:outline-none focus:border-gray-500 text-md  "
          />
        </div>
      )}
    </div>
  );
}

export default Disability;
